import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Tab, Row, Nav } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';
import { Route, Switch, NavLink } from 'react-router-dom';
import { Badge } from 'ecs-react-components/dist/index.es';

import { messages } from './HomePage.i18n';
import Message from '../../containers/Message/Message';
import { mapCapabilities } from './capability-mapper';
import { getUnreadCount } from '../../redux/modules/secure-message/secure-message-middleware';
import { DashboardPage } from '../DashboardPage/DashboardPage';
import { AppointmentsPage } from '../AppointmentsPage/AppointmentsPage';
import { EducationArticlesPage } from '../EducationArticlesPage/EducationArticlesPage';
import { FollowUpPlanPage } from '../FollowUpPlanPage/FollowUpPlanPage';
import TestResultsPage from '../TestResultsPage/TestResultsPage';
import { MedicalNotesPage } from '../MedicalNotesPage/MedicalNotesPage';
import { TreatmentSummaryPage } from '../TreatmentSummaryPage/TreatmentSummaryPage';
import QuestionnairesPage from '../QuestionnairesPage/QuestionnairesPage';
import SecureMessagesPage from '../SecureMessagesPage/SecureMessagesPage';
import { HealthSummaryPage } from '../HealthSummaryPage/HealthSummaryPage';
import { AccountSettingsPage } from '../AccountSettingsPage/AccountSettingsPage';
import ActivityLogPage from '../ActivityLogPage/ActivityLogPage';
import { ContactUsPage } from '../ContactUsPage/ContactUsPage';
import FaqsPage from '../FaqsPage/FaqsPage';
import UsefulLinksPage from '../UsefulLinksPage/UsefulLinksPage';
import DownloadableFormsPage from '../DownloadableFormsPage/DownloadableFormsPage';
import { withAuth } from '../../containers/Authenticated';


class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.tabClickHandler = this.tabClickHandler.bind(this);
  }

  componentDidMount() {
    this.tabClickHandler();
  }

  getActiveTabKey() {
    if (this.props.location.pathname === '/') {
      return '/dashboard';
    }
    return this.props.location.pathname;
  }

  tabClickHandler() {
    // ***** HACK ALERT!!! ***** Stupid workaround because there is no push mechanism
    const { profile, dispatch } = this.props;
    if (profile.patient && profile.patient.patientId) {
      dispatch(getUnreadCount(profile.patient.patientId));
    }
  }

  renderTabIcon(iconClassName, tabName) {
    if (iconClassName) {
      const classNames = 'tab-menu-icon ' + iconClassName;
      return <div className={classNames} aria-hidden="true" data-qa-item={tabName + '-tab-icon'}></div>;
    }

    return null;
  }

  render() {
    const {
      capabilities,
      stateCounter,
      profile: {
        patient: {
          patientId,
        },
      },
      dispatch,
    } = this.props;

    const tabs = mapCapabilities(
      capabilities,
      stateCounter,
      patientId,
      dispatch).filter((a) => a.isTabItem); // Remove SecureMessage tab in home page

    tabs.sort((a, b) => a.tabSortOrder - b.tabSortOrder);

    return (
      <Tab.Container id="home-tabs" key={this.getActiveTabKey()} defaultActiveKey={this.getActiveTabKey()}>
        <div id="home-page">
          <Row>
              <div className="tab-menu-background theme d-none d-lg-block mb-2">
                <Nav id="home-tabs-navs" variant="tabs" className="reversed theme" onSelect={this.tabClickHandler}
                  role="menubar" as="ul"
                >
                  {
                    tabs.map((tab, tabIndex) => (
                      tab.route ?
                        <LinkContainer to={tab.route} key={tabIndex}>
                          <Nav.Item key={tab.id} role="tab" as="li">
                            <Nav.Link eventKey={tab.route} to={tab.route} as={NavLink}>
                            {this.renderTabIcon(tab.iconClassNames, tab.id)}
                            <div className="menu-tab" data-qa-tab={tab.id} role="menuitem" >
                              <FormattedMessage {...messages.tabs[tab.id]} />
                            </div>
                            <Badge badgeProperties={tab.badgeProperties} />
                            </Nav.Link>
                          </Nav.Item>
                        </LinkContainer>
                        : null
                    ))
                  }
                </Nav>
              </div>
          </Row>
          <Message />
          <Tab.Content id="home-tabs-navs-contents">
            <Switch>
              <Route path="/" exact module="dashboard" component={DashboardPage} />
              <Route path="/dashboard" module="dashboard" component={DashboardPage} />
              <Route path="/appointments" module="appointments" component={AppointmentsPage} />
              <Route path="/education-articles" module="educationarticles" component={EducationArticlesPage} />
              <Route path="/followup-plan" module="followups" component={FollowUpPlanPage} />
              <Route path="/test-results" module="testresults" component={TestResultsPage} />
              <Route path="/medical-notes" module="medicalnotes" component={MedicalNotesPage} />
              <Route path="/treatment-summary" module="treatmentsummary" component={TreatmentSummaryPage} />
              <Route path="/questionnaires" module="questionnaires" component={QuestionnairesPage} />
              <Route path="/secure-messages" module="securemessages" component={SecureMessagesPage} />
              <Route path="/health-summary" component={HealthSummaryPage} />
              <Route path="/account-settings" component={AccountSettingsPage} />
              <Route path="/personal-data" component={ActivityLogPage} />
              <Route path="/contact-us" component={ContactUsPage} />
              <Route path="/faqs" component={FaqsPage} />
              <Route path="/useful-links" component={UsefulLinksPage} />
              <Route path="/download-forms" component={DownloadableFormsPage} />
            </Switch>
          </Tab.Content>
        </div>
      </Tab.Container>
    );
  }
}

HomePage.propTypes = {
  dispatch: PropTypes.func,
  capabilities: PropTypes.array,
  profile: PropTypes.object,
  user: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  stateCounter: PropTypes.shape({
    education: PropTypes.number,
    testresults: PropTypes.number,
    medicalnotes: PropTypes.number,
    questionnaires: PropTypes.number,
    treatmentsummary: PropTypes.number,
    securemessages: PropTypes.number,
  }),
};

const mapStateToProps = (state, ownProps) => ({
  capabilities: state.capability.capabilities,
  profile: state.profile,
  user: state.user,
  location: ownProps.location,
  stateCounter: {
    education: state.education.unreadArticlesCount,
    testresults: state.testResults.notReviewedTestResultsCount,
    medicalnotes: state.medicalNotes.isNotReviewedByPatientCount,
    questionnaires: state.questionnaires.newQuestionnaireCount,
    treatmentsummary: state.treatmentSummary.unseenTreatmentSummaryItems,
    securemessages: state.secureMessage.unreadCount,
  },
});

const HomePageWithAuth = withAuth(HomePage);

export default connect(mapStateToProps)(HomePageWithAuth);